import React, {Component} from "react";
import moment from "moment";
import Api from "../../api/Api";
import {toast} from "react-toastify";
import VerificationPopUp from "./VerificationPopUp";
import './PisaasInstanceInfo.css'
import PisaasInstanceContainerInfoPopUp from "./PisaasInstanceContainerInfoPopUp";
import Authentication from "../../authentication/Authentication";
import LoadingSlideshow from "../loading/LoadingSlideshow"

export default class PisaasInstanceInfo extends Component {

    verificationTypes = {
        stop: 'stop',
        reactivate: 'reactivate',
        terminate: 'terminate'
    };

    packageId = {
        service_suspended: 5,
        trypi: 8,
        pisaas: 7
    }

    constructor(props) {
        super(props);

        this.state = {
            verificationPopupStopInstance: false,
            verificationPopupReactivateInstance: false,
            verificationPopupTerminateInstance: false,
            showContainerInfo: false,
            dashboardStatus: false,
            showLoading: true,
            showProgressBar: false,
            percentageProgress: null,
            showErrorMessage: false,
            isTrypi: this.props.piSaasInstance.package_id === this.packageId.trypi
        };

        this.authentication = new Authentication();
    };

    componentDidMount() {
        this.getRunningJobs()
        this.instanceProgressInterval = setInterval(this.getRunningJobs, 10000);
        this.checkForRunningDashboard(this.props.piSaasInstance.domain);
        this.pisaasDashboardStatusInterval = setInterval(this.pisaasDashboardStatusRefresh, 10000);
    }

    pisaasDashboardStatusRefresh = () => {
        const api = new Api();
        const instanceType = this.props.piSaasInstance["trypi_url"] ? "trypi" : "pisaas";
        const trypiUrl = instanceType === "trypi" ? this.props.piSaasInstance["trypi_url"] : null;
        api.checkForRunningDashboard(this.setDashboardStatus, function (err) {
            console.log(err);
            toast.error("Failed to reactivate instance", {
                position: toast.POSITION.BOTTOM_RIGHT
            })}, this.props.piSaasInstance.domain, instanceType, trypiUrl);
    }

    componentWillUnmount() {
        if (this.pisaasDashboardStatusInterval) {
            clearInterval(this.pisaasDashboardStatusInterval);
        }

        if (this.instanceProgressInterval) {
            clearInterval(this.instanceProgressInterval);
        }
    };

    checkForRunningDashboard = (domain) => {
        const api = new Api();
        const instanceType = this.props.piSaasInstance["trypi_url"] ? "trypi" : "pisaas";
        const trypiUrl = instanceType === "trypi" ? this.props.piSaasInstance["trypi_url"] : null;
        api.checkForRunningDashboard(this.setDashboardStatus, function (err) {
                console.log(err);
                toast.error("Failed to reactivate instance", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })}
            , domain, instanceType, trypiUrl);
    }

    calculateProgress = (jobs) => {
        if (jobs.length === 0 && this.state.dashboardStatus === "running") {
            if (this.instanceProgressInterval) {
                clearInterval(this.instanceProgressInterval);
            }
            this.setState({
                percentageProgress: 100,
                showProgressBar: false,
                showLoading: false,
                showDuplicatingMessage: false,
            })
        } else if (jobs.length === 0 && this.state.dashboardStatus !== 'running') {
            this.setState({
                percentageProgress: 96,
                showProgressBar: false,
                showLoading: true,
                showDuplicatingMessage: false,
            })
        } else if (jobs.some((job) => job.failed)) {
            this.setState({
                showErrorMessage: true,
                showLoading: false,
                showProgressBar: false,
                showDuplicatingMessage: false,
            })
        } else if (jobs.some((job) => job.is_duplicating)) {
            this.setState({
                showDuplicatingMessage: true,
                showLoading: false,
                showProgressBar: true,
                showErrorMessage: false
            })
        } else {
            const jobAsPercentage = 100 / (jobs[0]?.total_steps + 1)
            const isDashboardUp = this.state.dashboardStatus === "running"
            const percentageProgress = Math.round(jobAsPercentage * (jobs[0]?.completed_steps + (isDashboardUp ? 1 : 0)))
            this.setState({
                percentageProgress: percentageProgress,
                showProgressBar: true,
                showLoading: false,
                showDuplicatingMessage: false,
            })
        }
    }

    getRunningJobs = () => {
        if (this.props.piSaasInstance.package_id !== this.packageId.service_suspended) {
            const api = new Api();
            api.pisaasFetchJobProgress(this.calculateProgress, function (err) {
                console.log(err);
                toast.error("Failed to stop instance", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }, this.props.piSaasInstance.pisaas_instance_id)
        } else {
            this.setState({
                showLoading: false
            })
        }
    }

    setDashboardStatus = (res) => {
        if (res.data === "true") {
            this.setState({
                dashboardStatus: "running"
            })
        } else {
            this.setState({
                dashboardStatus: false
            })
        }
    }

    formatDate(date) {
        const momentDate = moment(date)
        if (momentDate.isValid()) {
            return momentDate.format("MMMM Do YYYY");
        }
        return "";
    };


    formatTime(date) {
        const momentDate = moment(date)
        if (momentDate.isValid()) {
            return momentDate.format("HH:mm:ss")
        }
        return "";
    };

    toggleVerificationPopup(verificationType) {
        if (verificationType === this.verificationTypes.stop) {
            this.setState(
                {
                    verificationPopupStopInstance: !this.state.verificationPopupStopInstance,
                    verificationPopupReactivateInstance: false,
                    verificationPopupTerminateInstance: false
                }
            );
        }

        if (verificationType === this.verificationTypes.reactivate) {
            this.setState(
                {
                    verificationPopupReactivateInstance: !this.state.verificationPopupReactivateInstance,
                    verificationPopupStopInstance: false,
                    verificationPopupTerminateInstance: false
                }
            );
        }

        if (verificationType === this.verificationTypes.terminate) {
            this.setState(
                {
                    verificationPopupTerminateInstance: !this.state.verificationPopupTerminateInstance,
                    verificationPopupStopInstance: false,
                    verificationPopupReactivateInstance: false
                }
            );
        }

    };

    showLoadAndRefresh = () => {
        this.setState({
            showLoading: true
        })

        this.props.refreshPisaasInstances()
    }

    handleStopInstance(serviceName, instanceId, isAdmin, isTrypi, region) {
        const api = new Api();

        if (isAdmin && isTrypi) {
            api.stopTrypiInstance(function (err) {
                console.log(err);
                toast.error("Failed to stop instance", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }, serviceName, instanceId, region);
        } else if (isAdmin) {
            api.stopPisaasInstance(function (err) {
                console.log(err);
                toast.error("Failed to stop instance", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }, serviceName, instanceId, region);
        }
    }


    handleReactivateInstance(serviceName, instanceId, packageId, region) {

        const api = new Api();

        if (packageId === 8) {
            api.reactivateTrypiInstance(function (err) {
                console.log(err);
                toast.error("Failed to reactivate instance", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }, serviceName, instanceId, region);
        } else {
            api.reactivatePisaasInstance(function (err) {
                console.log(err);
                toast.error("Failed to reactivate instance", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }, serviceName, instanceId, region);
        }
    };

    handleContainerPopUp = () => {
        this.setState({
            showContainerInfo: !this.state.showContainerInfo
        })
    }

    createContainerInfo = () => {
        const hasRunningDashboard = this.state.dashboardStatus === "running"

        if (hasRunningDashboard) {
            return (
                <div>
                    <div>
                        <span className="field-name gap-top-2">Status:</span><br/>
                        <i className={"fa fa-check mr-2 green-tick"}
                           data-testid="instance.status"
                           aria-hidden="true"/><span data-testid="instance.status.text">RUNNING</span><br/>
                    </div>
                    <div>
                        {

                            !this.state.isTrypi ? <div><i onClick={() => this.handleContainerPopUp()} className={"fa fa-info-circle"} data-testid="instance.healthInfo.button" aria-hidden={true}/> Service Health Info</div> : <></>}
                        {this.state.showContainerInfo ? <PisaasInstanceContainerInfoPopUp pisaasInstance={this.props.piSaasInstance} togglePopUp={this.handleContainerPopUp}/> : <></>}
                    </div>
                </div>
            )
        } else {
            const status = this.props.piSaasInstance.package_id === this.packageId.service_suspended ? "STOPPED" : "PENDING"
            return (
                <>
                    <div>
                        <span className="field-name gap-top-2">Status:</span><br/>
                        <i className={"fa fa-close red-icon"}
                           data-testid="instance.status"
                           aria-hidden="true"/><span data-testid="instance.status.text">{status}</span><br/>
                    </div>
                </>
            )
        }
    }

    getLocaleTime = () => {
        const databaseTime = new Date(this.props.piSaasInstance.current_time_utc).getTime();
        const signupDate = new Date(this.props.piSaasInstance.signup_startdate).getTime();
        const currentLocaleDate = new Date().getTime();
        const UTCLocaleDifference = Math.round((currentLocaleDate - databaseTime) / 100000) * 100000;
        const momentDate = moment(signupDate + UTCLocaleDifference)
        momentDate.format("MMMM Do YYYY HH:mm:ss")
        return momentDate
    }

    handleTerminate = (domain, instanceId, region) => {
        const api = new Api();

        api.pisaasTerminate(function (err) {
            console.log(err);
            toast.error("Failed to reactivate instance", {
                position: toast.POSITION.BOTTOM_RIGHT
            })}, domain, instanceId, region);
    }

    render() {
        const hasRunningDashboard = this.state.dashboardStatus === "running"
        const url = this.props.piSaasInstance["trypi_url"] ? this.props.piSaasInstance["trypi_url"] : this.props.piSaasInstance.url
        const localTime = this.getLocaleTime()
        if (this.state.showProgressBar) {
            return (
                <div>
                    <LoadingSlideshow percentageProgress={this.state.percentageProgress}
                                      instance={this.props.piSaasInstance} showDuplicatingMessage={this.state.showDuplicatingMessage}/>
                </div>
            )
        } else if (this.state.showLoading) {
            return (
                <div layout="" horizontal="" className="instance-information-container gap-top-4 loading-box">
                    <div flex="" className="info-cell" layout="" vertical="">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw instance-loading"/>
                    </div>
                </div>
            )

        } else if (this.state.showErrorMessage) {
            return (
                <div layout="" horizontal="" className="instance-information-container gap-top-4 loading-box">
                    <div flex="" className="info-cell" layout="" vertical="">
                        <div className={"error-message"} data-testid="instance.error">
                            <p>Something has gone wrong while preparing your instance</p>
                            <p>We will look to resolve this for you as soon as possible</p>
                            <p>Please wait a couple minutes or message support@panintelligence.com</p>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div layout="" horizontal="" className="instance-information-container gap-top-4">
                    <div flex="" className="info-cell" layout="" vertical="">
                        {this.authentication.isAdmin ?
                            <div>
                                <span className="field-name" data-testid="instance.infoTitle.type">Type: </span>
                                <span className="info-block" data-testid="instance.info.type">{this.props.piSaasInstance.package_id === this.packageId.trypi || this.props.piSaasInstance.trypi_url ? "TryPi" : "Pisaas"}</span>
                            </div> :
                            <></>
                        }
                        <div>
                            <span className="field-name" data-testid="instance.infoTitle.region">Region:</span>
                            <span className="info-block" data-testid="instance.info.region">{this.props.piSaasInstance.region}</span>
                        </div>
                        <div>
                            <span className="field-name" data-testid="instance.infoTitle.owner">Instance Owner:</span><br/>
                            <span className="info-block" data-testid="instance.info.owner">{this.props.piSaasInstance.email}</span>
                        </div>
                        <div>
                            <i className="fa fa-calendar-check-o mr-2 date-icon"
                               aria-hidden="true"/>
                            <span className="field-name" data-testid="instance.infoTitle.startDate">Start Date:</span><br/>
                            <span className="date-and-time" data-testid="instance.info.startDate">{this.formatDate(localTime)}</span>
                            <span className="date-and-time" data-testid="instance.info.startTime">{this.formatTime(localTime)}</span>
                        </div>
                        <div>
                            <span className="field-name" data-testid="instance.infoTitle.URL">URL:</span><br/>
                            <span className="info-block" data-testid="instance.info.URL">{this.props.piSaasInstance.package_id === this.packageId.trypi ? this.props.piSaasInstance.trypi_url ? `https://${this.props.piSaasInstance["trypi_url"]}` : "Pending" : this.props.piSaasInstance.url}</span>
                        </div>
                        {this.createContainerInfo()}
                    </div>
                    <div flex="">
                        <div className="dashboard-btn-container" data-testid="instance.buttonContainer" layout="" vertical="">
                            <div flex="" className="dashboard-btn-wrapper gap-top-4">
                                    {this.state.dashboardStatus === "running" ?
                                        <a href={"https://" + url} target={'_blank'}
                                           rel="noopener noreferrer"
                                           className={"link"}>
                                            <button className="try-pi-button try-pi-drop-in-button" data-testid="instance.button.launch">
                                                Launch
                                            </button>
                                        </a>
                                        :
                                        <button onClick={() => this.toggleVerificationPopup(this.verificationTypes.terminate)} className="try-pi-button try-pi-button" data-testid="instance.button.terminate">
                                            Terminate
                                        </button>
                                    }

                            </div>
                            {hasRunningDashboard && this.authentication.isAdmin() ?
                                <div flex="" className="dashboard-btn-wrapper ">
                                    <button onClick={() => this.toggleVerificationPopup(this.verificationTypes.stop)}
                                            rel="noopener noreffer"
                                            data-testid="instance.button.stop"
                                            className="try-pi-button">Stop Instance
                                    </button>
                                </div> :
                                <></>
                            }
                            {!hasRunningDashboard && this.props.piSaasInstance.package_id !== this.packageId.trypi && this.props.piSaasInstance.package_id !== this.packageId.pisaas && !this.props.piSaasInstance.trypi_url ?
                                <div flex="" className="dashboard-btn-wrapper ">
                                    <button onClick={() => this.toggleVerificationPopup(this.verificationTypes.reactivate)}
                                            rel="noopener noreffer"
                                            className="try-pi-drop-in-button" data-testid="instance.button.reactivate">Reactivate Instance
                                    </button>
                                </div>
                                : <></>
                            }
                        </div>
                    </div>
                    <div flex="vertical">
                        {this.state.verificationPopupStopInstance ? <VerificationPopUp
                            toggle={() => this.toggleVerificationPopup(this.verificationTypes.stop)}
                            title="Stop Instance"
                            instruction="stop instance"
                            instanceId={this.props.piSaasInstance.pisaas_instance_id}
                            verificationAction={this.handleStopInstance}
                            verifcationTypes={this.verificationTypes}
                            instancesRefresh={this.props.refreshPisaasInstances}
                            serviceName={this.props.piSaasInstance.domain}
                            isAdmin={this.props.isAdmin}
                            isTrypi={this.state.isTrypi}
                            showLoadAndRefresh={this.showLoadAndRefresh}
                            region={this.props.piSaasInstance.region}
                        /> : null}
                        {this.state.verificationPopupReactivateInstance ? <VerificationPopUp
                            toggle={() => this.toggleVerificationPopup(this.verificationTypes.reactivate)}
                            title="Reactivate Instance"
                            instruction="Reactivate instance"
                            instanceId={this.props.piSaasInstance.pisaas_instance_id}
                            verificationAction={this.handleReactivateInstance}
                            verifcationTypes={this.verificationTypes}
                            instancesRefresh={this.props.refreshPisaasInstances}
                            serviceName={this.props.piSaasInstance.domain}
                            packageId={this.props.piSaasInstance.package_id}
                            showLoadAndRefresh={this.showLoadAndRefresh}
                            region={this.props.piSaasInstance.region}
                        /> : null}
                        {this.state.verificationPopupTerminateInstance ? <VerificationPopUp
                            toggle={() => this.toggleVerificationPopup(this.verificationTypes.terminate)}
                            title="Terminate Instance"
                            instruction="Terminate instance"
                            instanceId={this.props.piSaasInstance.pisaas_instance_id}
                            verificationAction={this.handleTerminate}
                            verifcationTypes={this.verificationTypes}
                            instancesRefresh={this.props.refreshPisaasInstances}
                            serviceName={this.props.piSaasInstance.domain}
                            showLoadAndRefresh={this.showLoadAndRefresh}
                            region={this.props.piSaasInstance.region}
                        /> : null}
                    </div>
                </div>
            );
        }
    }
}



